import { render } from "./대장내시경.vue?vue&type=template&id=684442ca"
import script from "./대장내시경.vue?vue&type=script&lang=js"
export * from "./대장내시경.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__